import { render, staticRenderFns } from "./TablePartners.vue?vue&type=template&id=64cd060b"
import script from "./TablePartners.vue?vue&type=script&lang=js"
export * from "./TablePartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports